var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal",attrs:{"id":_vm.id}},[_c('div',{staticClass:"modal-content"},[_c('h4',[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.content))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},_vm._l((_vm.actions),function(action,name){return _c('a',{key:name,staticClass:"modal-close waves-effect waves-green btn-flat",on:{"click":action}},[_vm._v(_vm._s(name))])}))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f67c1ba","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = null
// module chunks = 